'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardActionsMainStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

var _CardAreaSideStyled = require('../../../CardAreaSide/styles/CardAreaSideStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
  theme: _propTypes2.default.object
};
var defaultProps = {
  size: 'default'
};
/** Prop Receivers */

var sizeProps = function sizeProps(_ref) {
  var themeFromProvider = _ref.theme,
      size = _ref.size;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.card.actions.size[size],
      itemsSpacingHorizontal = _theme$reactackle$com.itemsSpacingHorizontal,
      itemsSpacingVertical = _theme$reactackle$com.itemsSpacingVertical;
  var itemsMarginY = (0, _reactackleCore.getValueString)(itemsSpacingVertical),
      itemsMarginX = (0, _reactackleCore.getValueString)(itemsSpacingHorizontal);
  return (0, _styledComponents.css)(['margin:-', ' -', ';justify-content:flex-end;& > *{margin:', ' ', ';}', ' &{flex-direction:column;align-items:flex-start;justify-content:flex-start;}'], itemsMarginY, itemsMarginX, itemsMarginY, itemsMarginX, _CardAreaSideStyled.CardAreaSideStyled);
};
/** Styles */


var CardActionsMainStyled = exports.CardActionsMainStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardActionsMainStyled'
})(['display:flex;flex-grow:1;text-align:right;', ';'], sizeProps);

CardActionsMainStyled.propTypes = propTypes;
CardActionsMainStyled.defaultProps = defaultProps;
CardActionsMainStyled.displayName = 'CardActionsMainStyled';